/*
 * @Author: zhangyuan zhangyuan@cheyipai.com
 * @Date: 2022-08-24 16:07:02
 * @LastEditors: zhangyuan your_email
 * @LastEditTime: 2024-09-27 10:40:02
 * @FilePath: /report-template/src/service/index.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios from './axios';
import md5 from "js-md5";

const {VUE_APP_FINSNCE_JSON_URL, VUE_APP_FINSNCE_URL, VUE_APP_DANUBE} = process.env
/**
 * 获取检测数据
 * */
export const GetReportViewModelFromServe = (data: any) => {
    const {reportCode, reportLevel, templateCode, reportVersion} = data;
    let url = `${VUE_APP_FINSNCE_URL}/detect/report/reportApi/getConsumerReport`
    return axios({
        method: 'get',
        url,
        data: {
            reportVersion: reportVersion || 'tocv001',
            reportCode,
            regenerate:1,
            reportLevel,
            templateCode,
        }
    })
}
/**
 * 获取中汽研检测数据
 * */
export const GetZQYReportViewModelFromServe = (data: any) => {
    const {reportCode, reportLevel, templateCode, reportVersion} = data;
    let url = `${VUE_APP_FINSNCE_URL}/detect/report/reportApi/getConsumerReportCaeri`
    return axios({
        method: 'get',
        url,
        data: {
            reportVersion: reportVersion || 'tocv001',
            reportCode,
            regenerate:1,
            reportLevel,
            templateCode,
        }
    })
}
/**
 * 获取静态化检测数据
 * */
export const GetReportViewModelFromJSON = (data: any) => {
    const {reportCode, reportVersion, templateCode} = data;
    let md5S = md5(reportCode.toLowerCase() + (reportVersion || 'tocv001'));
    let md5String = md5S.substring(md5S as any, 4);
    let url;
    if(templateCode){
        url = (`${VUE_APP_FINSNCE_JSON_URL}/report268v/${md5String}/${reportVersion || 'tocv001'}/${reportCode}_getConsumerReport${templateCode}.json`).toLowerCase()
    }else{
        url = (`${VUE_APP_FINSNCE_JSON_URL}/v/${md5String}/${reportVersion || 'tocv001'}/${reportCode}_getConsumerReport.json`).toLowerCase()
    }
    return axios({
        method: 'get',
        url,
        timeout: 10000,
        isStatic: true,
        resHasData: true
    });
}
/**
 * 获取中汽研静态化检测数据
 * */
export const GetZQYReportViewModelFromJSON = (data: any) => {
    const {reportCode, reportVersion, templateCode} = data;
    let md5S = md5(reportCode.toLowerCase() + (reportVersion || 'tocv001'));
    let md5String = md5S.substring(md5S as any, 4);
    let url;
    if(templateCode){
        url = (`${VUE_APP_FINSNCE_JSON_URL}/report268v/${md5String}/${reportVersion || 'tocv001'}/${reportCode}_getConsumerReportCaeri${templateCode}.json`).toLowerCase()
    }else{
        url = (`${VUE_APP_FINSNCE_JSON_URL}/report268v/${md5String}/${reportVersion || 'tocv001'}/${reportCode}_getConsumerReportCaeri.json`).toLowerCase()
    }
    return axios({
        method: 'get',
        url,
        timeout: 10000,
        isStatic: true,
        resHasData: true
    });
}

/**
 * 是否冲销
 * */
export const GetVerifyEffectiveReport = (data: any) => {
    const {reportCode} = data;
    let url = `${VUE_APP_DANUBE}/detect/detectInfoAction/cyp/verifyEffectiveReport.json`
    return axios({
        method: 'get',
        url,
        data: {
            reportCode
        }
    });
}
/**
 * 是否需要跳转到车况报告
 * */
export const GetCheKuangReportUrl = (data: any) => {
    const {reportCode, templateCode} = data;
    let url = `${VUE_APP_FINSNCE_URL}/detect/report/reportApi/getCheKuangReportUrl`
    return axios({
        method: 'get',
        url,
        data: {
            reportCode,
            templateCode
        }
    });
}
/**
 * 获取闲鱼报告数据
 */
export const GetIdleFishReportService = (data: any) => {
    const {reportCode} = data;
    let url = `${VUE_APP_FINSNCE_URL}/detect/report/reportApi/getIdleFishReport`
    return axios({
        method: 'get',
        url,
        data: {
            reportCode
        }
    })
}
/**
 * 获取闲鱼报告静态数据
 */
 export const GetIdleFishReportJSON = (data: any) => {
    const {reportCode} = data;
    let md5S = md5(reportCode.toLowerCase() + 'no_cert_report_idlefish_with_sign_299' + 'tocv001')
    let md5String = md5S.substring(md5S as any, 4)
    let url = (`${VUE_APP_FINSNCE_JSON_URL}/report268v/${md5String}/tocv001/no_cert_report_idlefish_with_sign_299/${reportCode}_getIdleFishReport.json`).toLowerCase()
    return axios({
        method: 'get',
        url,
        timeout: 10000,
        isStatic: true,
        resHasData: true
    });
}

/**
 * 获取报告预览接口数据
 */
export const GetDetectPreview = (data: any) => {
   const {reportCode, token} = data;
   let url = `${VUE_APP_FINSNCE_URL}/detect/cloud/detectOrderApi/getDetectPreview`
   return axios({
       method: 'get',
       url,
       header: {
        'Souche-Security-Token': token
       },
       data: {
            reportCode
        }
   });
}

/**
 * 获取阿里云视频auth
 * */
export function getVideoPlayAuth(opts) {
    let url = `${VUE_APP_FINSNCE_URL}/detect/report/reportApi/getVideoPlayAuth?videoId=${opts.videoId}`;
    return axios({
        method: 'get',
        url
    });
}
/**
 * 获取报告照片数据
 * */
export const getTslPhotoInfo = (data: any) => {
    const {reportCode, templateCode} = data;
    let url = `${VUE_APP_FINSNCE_URL}/detect/report/reportPhotoApi/getTslPhotoInfo`
    return axios({
        method: 'get',
        url,
        data: {
            reportCode,
            templateCode,
        }
    })
}
/**
 * 获取老报告pdf地址
 * */
export const GetOldReportPdfUrl = (data: any) => {
    const {reportCode, templateCode, reportLevel} = data;
    let url = `${VUE_APP_FINSNCE_URL}/detect/report/reportApi/getOldReportPdfUrl`
    return axios({
        method: 'get',
        url,
        data: {
            reportCode,
            templateCode,
            reportLevel
        }
    })
}
/**
 * 获取复检报告
 * */
export const getDetectDiffReport = (data: any) => {
    const {reportCode, templateCode, reportLevel} = data;
    let url = `${VUE_APP_FINSNCE_URL}/detect/report/reportApi/getDetectDiffReport`
    return axios({
        method: 'get',
        url,
        data: {
            reportCode,
            templateCode,
            reportLevel
        }
    })
}

/**
 * 获取车辆拆解视频
 * swagger: http://souche-detect-cloud.svc.test.suixinhuan.com/api#!/carsamplevideoapi/getCarSampleVideo
 */

export const getCarSampleVideo = (data: any) => {
    let url = `${VUE_APP_FINSNCE_URL}/detect/cloud/carSampleVideoApi/getCarSampleVideo`
    return axios({
        method: 'get',
        url,
        header: {
            'Souche-Security-Token': data.token
        },
        data: {
            reportCode: data.reportCode
        }
    })
}
/**
 * 车辆保存拆解视频留言
 */

export const saveCarSampleComment = (data: any) => {
    let url = `${VUE_APP_FINSNCE_URL}/detect/cloud/carSampleVideoApi/saveCarSampleComment`
    return axios({
        method: 'post',
        url,
        header: {
            'Souche-Security-Token': data.token
        },
        data: {
            id: data.id,
            comment: data.comment
        }
    })
}
/**
 * 更新拆解视频差评，count为1则差评，为-1则取消差评
 */

export const updateCarSampleVideoBad = (data: any) => {
    let url = `${VUE_APP_FINSNCE_URL}/detect/cloud/carSampleVideoApi/updateCarSampleVideoBad`
    return axios({
        method: 'get',
        url,
        data
    })
}
/**
 * 更新拆解视频好评，count为1则好评，为-1则取消好评
 */

export const updateCarSampleVideoGood = (data: any) => {
    let url = `${VUE_APP_FINSNCE_URL}/detect/cloud/carSampleVideoApi/updateCarSampleVideoGood`
    return axios({
        method: 'get',
        url,
        data
    })
}
